class AuthenticityRegistry extends HTMLElement {
  connectedCallback() {
    this.searchInput = this.querySelector('[ref="searchInput"]');
    this.rows = Array.from(this.querySelectorAll('[data-registry-row]'));
    this.resultCount = this.querySelector('[ref="resultCount"]');
    this.noResults = this.querySelector('[ref="noResults"]');

    this.searchInput?.addEventListener('input', this.handleSearch);
    this.updateResultCount(this.rows.length);
  }

  disconnectedCallback() {
    this.searchInput?.removeEventListener('input', this.handleSearch);
  }

  handleSearch = () => {
    const query = this.normalize(this.searchInput?.value ?? '');
    let visibleRows = 0;

    for (const row of this.rows) {
      const haystack = this.normalize(row.getAttribute('data-search') ?? row.textContent ?? '');
      const isVisible = !query || haystack.includes(query);

      row.hidden = !isVisible;
      if (isVisible) visibleRows += 1;
    }

    this.updateResultCount(visibleRows);
    this.noResults?.classList.toggle('hidden', visibleRows > 0 || this.rows.length === 0);
  };

  normalize(value) {
    return value
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  updateResultCount(count) {
    if (!this.resultCount) return;

    this.resultCount.textContent = `${count} ${count === 1 ? 'registro' : 'registros'}`;
  }
}

if (!customElements.get('authenticity-registry')) {
  customElements.define('authenticity-registry', AuthenticityRegistry);
}
